import { useEffect, useMemo } from 'react';

import tagAction from '../actions/tag.action';
import useDispatch from '../hooks/useDispatch';
import useSelector from '../hooks/useSelector';

export const parseEvaluation = (
  evaluation: string
): ((tickerWithCategory: string) => boolean) => {
  return eval(evaluation);
};

export const useTagEvaluation = (): ((
  tickerWithCategory: string
) => boolean) => {
  const {
    getStockTags: { tags, stocksByTag },
    selected,
  } = useSelector(state => state.tag);

  if (selected !== '') {
    const stocksInSelectedtag = stocksByTag && stocksByTag[selected];
    const selectedTag = tags.find(tag => tag.id === selected);
    if (selectedTag) {
      return selectedTag.evaluation
        ? parseEvaluation(selectedTag.evaluation)
        : (tickerWithCategory: string) =>
            stocksInSelectedtag.has(tickerWithCategory);
    }
  }

  return () => true;
};

export const useTags = () => {
  const {
    getStockTags: { loading, tags },
  } = useSelector(state => state.tag);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!loading && !tags) {
      dispatch(tagAction.getStockTags());
    }
  }, [dispatch, loading, tags]);

  return tags || [];
};

export const useAllTagEvaluations = (): Record<
  string,
  (tickerWithCategory: string) => boolean
> => {
  const {
    getStockTags: { tags, stocksByTag },
  } = useSelector(state => state.tag);

  return useMemo(() => {
    if (!tags) {
      return {};
    }

    return Object.fromEntries(
      tags.map(tag => {
        const stocksInTag = stocksByTag && stocksByTag[tag.id];
        return [
          tag.id,
          tag.evaluation
            ? parseEvaluation(tag.evaluation)
            : (tickerWithCategory: string) =>
                stocksInTag.has(tickerWithCategory),
        ];
      })
    );
  }, [stocksByTag, tags]);
};
